import { FC, PropsWithChildren } from 'react';

import { Center, Flex, rem, StyleProps, Text } from '@bonusly/design-system';

import { AnimatedBubbles } from './animated-bubbles';

interface PageLoadingProps extends PropsWithChildren, StyleProps {
	children?: string;
	topNav?: boolean;
}

export const PageLoading: FC<PageLoadingProps> = ({ children, topNav = false, ...rest }) => {
	const topOffset = topNav ? rem(64) : '0rem';

	return (
		<Center h={`calc(100vh - ${topOffset})`} {...rest}>
			<Flex alignItems="center" flexDir="column" pos="relative" w={rem(400)}>
				<AnimatedBubbles />
				{children && (
					<Text bottom={rem(40)} fontWeight="semibold" pos="absolute">
						{children}
					</Text>
				)}
			</Flex>
		</Center>
	);
};
